import React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { Link } from 'gatsby';
import FancyTitle from '../fancy-title';
import Container from '../Container';
import { getStoryblokAlt } from '../../helpers/common';

function ClientLogo({ image, url, decorative = false }) {
  if (!image?.filename) return null;
  const src = !image.filename.includes('.svg')
    ? `${image.filename}/m/288x0/filters:format(webp)`
    : image.filename;
  const resolvedAlt = getStoryblokAlt(image, image.title || image.name || '');
  // Duplicated logos exist only for the seamless marquee loop and must be hidden from assistive tech
  const alt = decorative ? '' : resolvedAlt;
  return (
    <div className="flex items-center justify-center">
      {!decorative && url && url.story && url.story.full_slug ? (
        <Link
          to={url.story.full_slug}
          title={url?.link_title || undefined}
          aria-label={resolvedAlt}
          className="block"
        >
          <img
            src={src}
            alt={alt}
            width={image.logoWidth || 144}
            height={image.logoHeight || 48}
            className="h-12 w-auto max-w-[144px] object-contain"
            loading="lazy"
          />
        </Link>
      ) : (
        <img
          src={src}
          alt={alt}
          aria-hidden={decorative || undefined}
          width={image.logoWidth || 144}
          height={image.logoHeight || 48}
          className="h-12 w-auto max-w-[144px] object-contain"
          loading="lazy"
        />
      )}
    </div>
  );
}

export default function ClientLogosSection({ blok }) {
  if (!blok.blocks?.length) return null;
  const titleBlock = blok.blocks.find((item) => item.component === 'headlines');
  const logosBlock = blok.blocks.find((item) => item.component === 'client-logo');

  const logos = logosBlock ? blok.blocks.filter((item) => item.component === 'client-logo') : [];
  return (
    <div {...storyblokEditable(blok)} className="pb-12 lg:pb-20">
      <Container className="">
        {titleBlock && (
          <FancyTitle
            text={titleBlock.headline}
            subtitle={titleBlock.subline}
            className="text-center"
            tag="h2"
            textAlign="lg:text-center"
            marginBottom="mb-10 lg:mb-16"
          />
        )}

        {logosBlock && (
          <div className="overflow-hidden w-full">
            <div className="logos-marquee-track" aria-hidden="false">
              {logos.map(({ _uid, image, url }) => (
                <div key={_uid} className="flex items-center justify-center px-8">
                  <ClientLogo image={image} url={url} />
                </div>
              ))}
              {/* Duplicate for seamless loop */}
              {logos.map(({ _uid, image, url }) => (
                <div
                  key={`dup-${_uid}`}
                  className="flex items-center justify-center px-8"
                  aria-hidden="true"
                >
                  <ClientLogo image={image} url={url} decorative />
                </div>
              ))}
            </div>
          </div>
        )}
      </Container>
    </div>
  );
}
